import React from 'react';
import ReactDOM from 'react-dom';
import Rotas from './routes/Rotas';

import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Rotas />
  </React.StrictMode>,
  document.getElementById('root')
);